import { useQueryString } from "hooks/searchFilterHooks"
import React from "react"
import ViewTripsMap from "../map/ViewTripsMap"
import AssignedTable from "../table/AssignedTable"
function AssignedVehiclesPage() {
  const [type] = useQueryString("type")

  return <>{type === "list" ? <AssignedTable /> : <ViewTripsMap />}</>
}

export default AssignedVehiclesPage
